"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _pfaHero = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.defaultProps"));
var _pfaHero2 = _interopRequireDefault(require("./pfa-hero.props/pfa-hero.propTypes"));
var _pfaHeroBackground = _interopRequireDefault(require("./pfa-hero-background"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } // We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var PFAHero = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(PFAHero, _React$Component);
  function PFAHero() {
    return _React$Component.apply(this, arguments) || this;
  }
  PFAHero.resourceType = function resourceType() {
    return 'PFA_Hero_1_0_0';
  };
  var _proto = PFAHero.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      defaultData = _this$props.defaultData,
      isCarousel = _this$props.isCarousel,
      theme = _this$props.theme;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement(_pfaHeroBackground["default"], {
      data: _objectSpread(_objectSpread({}, componentData), {}, {
        isCarousel: isCarousel
      }),
      theme: theme
    });
  };
  return PFAHero;
}(_react["default"].Component);
PFAHero.displayName = 'PFAHero';
PFAHero.defaultProps = {
  data: _pfaHero["default"],
  defaultData: _pfaHero["default"],
  isCarousel: false
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(PFAHero));
exports["default"] = _default;